import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'
import i18n from './i18n'
// Site-specific CRM config
import config from 'config'
import AppLayout from '@/layouts/Default'

import './styles/quasar.styl'
// import 'quasar-extras/roboto-font'
import 'quasar-extras/material-icons'
import {
  Loading,
  Notify,
  Meta,
  Quasar,
  QBtn,
  QCard,
  QCardSeparator,
  QCardTitle,
  QCheckbox,
  QDatetime,
  QDialog,
  QField,
  QInfiniteScroll,
  QInput,
  QLayout,
  QLayoutFooter,
  QLayoutHeader,
  QPage,
  QPageContainer,
  QRouteTab,
  QSearch,
  QSelect,
  QSpinnerDots,
  QToolbar,
  QToolbarTitle,
  QList,
  QTab,
  QTable,
  QTabPane,
  QTabs,
  QItem,
  QItemMain,
  QItemSide,
  QItemTile
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QCard,
    QCardSeparator,
    QCardTitle,
    QCheckbox,
    QDatetime,
    QDialog,
    QField,
    QInfiniteScroll,
    QInput,
    QLayout,
    QLayoutFooter,
    QLayoutHeader,
    QPage,
    QPageContainer,
    QRouteTab,
    QSearch,
    QSelect,
    QSpinnerDots,
    QToolbar,
    QToolbarTitle,
    QList,
    QTab,
    QTable,
    QTabPane,
    QTabs,
    QItem,
    QItemMain,
    QItemSide,
    QItemTile
  },
  directives: {
  },
  plugins: {
    Loading,
    Meta,
    Notify
  }
})

Vue.config.productionTip = false

Vue.component('app-layout', AppLayout)

// Axios config
axios.defaults.baseURL = config.crmAddress + '/api/v1'
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
// Log the user out if api returns "unauthorized" (eg. expired token)
axios.interceptors.response.use(undefined, err => {
  return new Promise((resolve, reject) => {
    if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
      store.dispatch('logout')
      // TODO: Show notification elsewhere but not in login
      // Notify.create({
      //   message: i18n.t('general.unauthorized'),
      //   position: 'top'
      // })
      return reject(err)
    }
    throw err
  })
})

// Set locale
const loc = localStorage.getItem('lang') || Quasar.i18n.getLocale()
if (Object.keys(i18n.messages).indexOf(loc) !== -1) {
  i18n.locale = loc
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
